import type { WSModel } from "@/services/socket/ws.service";
import { WSCommands } from "@/constants/ws";
import { useTripStore } from "@/store/trip.store";

export class TripMonitorHandler implements WSModel {
  private store = useTripStore();

  handleWSData(data: any) {
    if (!data.command) {
      return;
    }

    switch (data.command) {
      case WSCommands.tripMonitor:
        this.handleTripItem(data);
        break;
      case WSCommands.tripMonitorRoute:
        this.handleTripItemRoute(data);
        break;
      case WSCommands.tripTruck:
        this.handleTripTruck(data);
        break;
    }
  }

  private handleTripItemRoute(data: any) {
    if (data?.route) {
      this.store.setTripMonitorItemRoute(data.route);
    }
  }

  private handleTripTruck(data: any) {
    if (data?.truck) {
      this.store.setTripTruck(data.truck);
    }
  }

  private handleTripItem(data: any) {
    if (data?.trip) {
      this.store.setTripMonitorItem(data.trip);
    }
  }
}
